export default __webpack_public_path__ + "static/telesis_logo-a4d6b84681d416757959e1ca3931d17a.png";